import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Modal } from 'antd';
import styled from 'styled-components';
import DetailsCustomerModalContainer from './components/DetailsCustomerModalContainer';
import { useAppDispatch } from 'store/hooks';
import customerActions from 'features/customer/services/actions';

export type DetailsCustomerModalRef = {
  open: (id: string) => void;
};
type DetailsCustomerModalProps = {};

const DetailsCustomerModal = forwardRef<DetailsCustomerModalRef, DetailsCustomerModalProps>(
  ({}, ref) => {
    const [open, setOpen] = useState(false);
    const [id, setId] = useState<string>('');
    const dispatch = useAppDispatch();
    const onOpen = (id: string) => {
      setId(id);
      setOpen(true);
    };

    const onClose = () => {
      setOpen(false);
    };

    useImperativeHandle(ref, () => ({
      open: onOpen,
    }));

    useEffect(() => {
      if (id && open) {
        dispatch(customerActions.getCustomerDetails.fetch(id || ''));
        dispatch(customerActions.getSummaryReport.fetch(id || ''));
      }
    }, [open]);

    return (
      <DetailsCustomerModalStyled
        open={open}
        onCancel={onClose}
        title={null}
        footer={null}
        destroyOnClose={true}
        bodyStyle={{ padding: 0, margin: 0 }}
        closeIcon={null}
        centered
        width={'90vw'}
        closable={false}
      >
        <DetailsCustomerModalContainer onClose={onClose} />
      </DetailsCustomerModalStyled>
    );
  }
);

DetailsCustomerModal.displayName = 'DetailsCustomerModal';

export default DetailsCustomerModal;

const DetailsCustomerModalStyled = styled(Modal)`
  .ant-modal-content {
    opacity: 1;
  }
`;
